<template>
  <div class="hero-component">
    <div class="container">
      <div class="row">
        <div class="col-10 col-lg-8">
          <h1>{{ currentProduct.your_shortlist_heading }}</h1>

          <p>{{ description ? description.slice(0, 250) : '' }}

            <span class="read-more"
            v-if="description && (description.length > 250)"
            @click="showModal">... <span>read more</span></span>
          </p>

        </div>
        <div class="offset-1 col-3 d-flex align-items-center justify-content-end flex-wrap">
          <div class="w-100 d-flex align-items-center justify-content-end shortlist-count" v-if="shortListItemCount > 0">
            <span class="heading">{{ currentProduct.your_shortlist_employee_shortlisted_vehicle_count_heading }}</span>
            <span class="count">{{ shortListItemCount }}</span>
          </div>
        </div>

      </div>
      <div class="finance-example"
        v-if="scheme == 'ecoamaps' && currentProduct.finance_representative_example_required_on_page">
        <div class="example-item lead-example">
          <strong>{{ currentProduct.finance_representative_example_title }}</strong>
          <p v-html="currentProduct.finance_representative_example_description"></p>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_fixed_rate_of_interest_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_fixed_rate_of_interest_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_48_month_payments_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_48_month_payments_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_total_amount_payable_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_total_amount_payable_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_cost_of_credit_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_cost_of_credit_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_optional_final_payment_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_optional_final_payment_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_annual_mileage_limit_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_annual_mileage_limit_value }}</div>
        </div>
        <div class="example-item">
          <div class="label">{{ currentProduct.finance_representative_example_excess_mileage_charge_title }}</div>
          <div class="value">{{ currentProduct.finance_representative_example_excess_mileage_charge_value }}</div>
        </div>
      </div>
    </div>

    <text-modal-component v-if="readingMore" @close="showModal">
      <template v-slot:header>
        <h3>{{ currentProduct.your_shortlist_heading }}</h3>
      </template>
      <template v-slot:body>
        <p>{{ description }}</p>
      </template>
    </text-modal-component>

  </div>

</template>

<script>

import {EventBus} from '../event-bus.js';
import TextModalComponent from "./text-modal-component.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    TextModalComponent,
    EventBus
  },

  props: [
    'currentProduct',
    'scheme',
    'driverGrades'
  ],

  data: () => {
    return {
      shortListItemCount: 0,
      readingMore: false,
      driverGrade: null,
    }
  },

  mounted() {
    EventBus.$on('shortlistUpdated', (count) => {
      this.shortListItemCount = count;
    });
  },

  computed: {
    description() {
      return this.currentProduct.your_shortlist_description
        ? this.currentProduct.your_shortlist_description.replace('{SCHEME_NAME}', this.currentProduct.name)
        : '';
    },
  },

  methods: {
    showModal() {
      this.readingMore = !this.readingMore;
    }
  }
}

</script>
